// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import LucideController from "./lucide_controller"
application.register("lucide", LucideController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import TooltipsController from "./tooltips_controller"
application.register("tooltips", TooltipsController)

import LexxyEditorController from "./lexxy_editor_controller"
application.register("lexxy-editor", LexxyEditorController)

import DeliveryContactController from "./delivery_contact_controller"
application.register("delivery-contact", DeliveryContactController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import AmountFieldController from "./amount_field_controller"
application.register("amount-field", AmountFieldController)

import TimeFieldController from "./time_field_controller"
application.register("time-field", TimeFieldController)

import ElapsedTimeController from "./elapsed_time_controller"
application.register("elapsed-time", ElapsedTimeController)

import WeeklyTimesheetController from "./weekly_timesheet_controller"
application.register("weekly-timesheet", WeeklyTimesheetController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import DateNavigationController from "./date_navigation_controller"
application.register("date-navigation", DateNavigationController)

import TableScrollController from "./table_scroll_controller"
application.register("table-scroll", TableScrollController)

import ProjectFormController from "./project_form_controller"
application.register("project-form", ProjectFormController)

import ProjectChartController from "./project_chart_controller"
application.register("project-chart", ProjectChartController)

import DependentCheckboxController from "./dependent_checkbox_controller"
application.register("dependent-checkbox", DependentCheckboxController)

import InvoiceDueDateController from "./invoice_due_date_controller"
application.register("invoice-due-date", InvoiceDueDateController)

import BulkSelectionController from "./bulk_selection_controller"
application.register("bulk-selection", BulkSelectionController)

import ConditionalConfirmController from "./conditional_confirm_controller"
application.register("conditional-confirm", ConditionalConfirmController)

import CheckboxGroupController from "./checkbox_group_controller"
application.register("checkbox-group", CheckboxGroupController)

import DocumentEditorController from "./document_editor_controller"
application.register("document-editor", DocumentEditorController)

import CreatedRecordController from "./created_record_controller"
application.register("created-record", CreatedRecordController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import ExpenseCategoryFormController from "./expense_category_form_controller"
application.register("expense-category-form", ExpenseCategoryFormController)

import ExpenseFormController from "./expense_form_controller"
application.register("expense-form", ExpenseFormController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import DocumentGeneratorController from "./document_generator_controller"
application.register("document-generator", DocumentGeneratorController)

import FormDraftController from "./form_draft_controller"
application.register("form-draft", FormDraftController)

import PdfPreviewController from "./pdf_preview_controller"
application.register("pdf-preview", PdfPreviewController)

import PricingCalculatorController from "./pricing_calculator_controller"
application.register("pricing-calculator", PricingCalculatorController)

import SortableRowsController from "./sortable_rows_controller"
application.register("sortable-rows", SortableRowsController)

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)
